import styled from 'styled-components';

import { LoaderCircular } from '@vimeo/iris/motion';

const LoadingSpinner = styled(LoaderCircular)`
  margin: 30vh auto 40vh;
  display: flex;
  justify-content: center;
`;

export default LoadingSpinner;
